import React, {ReactElement} from 'react';
import {IValidationErrorObject} from '../../../../../incase-domain/common/validationErrorResponse';
import {IElementSequenceQuestion} from '../../../../../incase-domain/elements/question/questionSequence';
import {TABS} from '../../../form/part/tabs';
import ElementShadow from '../../common/elementShadow';
import {COLOR_FIELDS} from '../../common/fontAndBackgroundColorPicker';
import AdvancedOptions from '../components/advancedOptions/AdvancedOptions';
import QuestionOptions, {QUESTION_OPTIONS} from '../components/QuestionOptions';
import QuestionText from '../components/QustionText';
import SequencePreviewOrder from './sequence.previewOrder';
import SequenceQuestionAnswers from './SequenceQuestionAnswers';
import {useHighlightedElement, useSetHighlightedElement} from '../../../../../utils/hooks/slideUpdates/useSetSlideElement';
import AnimationForm from '../../common/animationForm';

interface HighlightedElementSequenceQuestionComponentProps {
    errors: IValidationErrorObject | null;
    activeTab: string;
}

function HighlightedElementSequenceQuestionComponent({errors, activeTab}: HighlightedElementSequenceQuestionComponentProps): ReactElement {
    const updateHighlightedElement = useSetHighlightedElement();
    const highlightedElement = useHighlightedElement() as IElementSequenceQuestion;

    if (activeTab === TABS.STYLE.id) {
        return (
            <>
                <AdvancedOptions
                    highlightedElement={highlightedElement}
                    highlightedElementChangeHandler={updateHighlightedElement}
                    answerColorFields={[COLOR_FIELDS.CORRECT_COLOR, COLOR_FIELDS.INCORRECT_COLOR]}
                    commentColorFields={[COLOR_FIELDS.CORRECT_COMMENT_COLOR, COLOR_FIELDS.INCORRECT_COMMENT_COLOR]}
                />
                <ElementShadow highlightedElement={highlightedElement} highlightedElementChangeHandler={updateHighlightedElement} />
            </>
        );
    }

    if (activeTab === TABS.ADVANCED.id) {
        return (
            <>
                <QuestionOptions
                    highlightedElement={highlightedElement}
                    highlightedElementChangeHandler={updateHighlightedElement}
                    questionOptions={[
                        QUESTION_OPTIONS.BLOCKING_QUESTION,
                        QUESTION_OPTIONS.SHOW_IN_REPORT,
                        QUESTION_OPTIONS.RETRY_QUESTION,
                        QUESTION_OPTIONS.DEBATABLE_QUESTION,
                    ]}
                />
                <AnimationForm
                    appearAfter={highlightedElement.appearAfter || 0}
                    elementAnimations={highlightedElement.elementAnimations}
                    highlightedElementChangeHandler={updateHighlightedElement}
                />
            </>
        );
    }

    return (
        <>
            <QuestionText
                highlightedElement={highlightedElement}
                errors={errors}
                highlightedElementChangeHandler={updateHighlightedElement}
            />
            <SequenceQuestionAnswers
                highlightedElement={highlightedElement}
                errors={errors}
                highlightedElementChangeHandler={updateHighlightedElement}
            />

            {!highlightedElement.isDebatable && (
                <SequencePreviewOrder highlightedElement={highlightedElement} highlightedElementChangeHandler={updateHighlightedElement} />
            )}
        </>
    );
}

export default HighlightedElementSequenceQuestionComponent;
